import { render, staticRenderFns } from "./StatusAndRating.vue?vue&type=template&id=f73a6580"
import script from "./StatusAndRating.vue?vue&type=script&lang=js"
export * from "./StatusAndRating.vue?vue&type=script&lang=js"
import style0 from "./StatusAndRating.vue?vue&type=style&index=0&id=f73a6580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports